import React, { useEffect, useState } from "react";
import { Tooltip, Box, Typography, IconButton, Button, Autocomplete, TextField } from '@mui/material';
import Card from "../../components/card/Card";
import ActionButton from "../../components/actionButton";
import TableContainer from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllPo } from "../../store/actions/po";
import receiver from '../../assets/receiver.png'
import details from '../../assets/details.png'
import PermissionComp from "../../components/permissionComp/permissionComp";
import { filterName } from "../../utils/Utils";
import ModalButton from "../../components/modalButton/modalButton";
import PoForm from "./poForm";
import PoDetail from "./poDetail";
import Grn from "../grn/grn";

const Po = () => {

    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { po } = useSelector(state => state.po)
    const { user } = useSelector(state => state.auth)
    const { vendorList } = useSelector(state => state.filler)
    const [Po, setPo] = useState([])
    const [open, setOpen] = React.useState(false);

    const [vendor, setVendor] = useState('')

    const tableHeader = ['PO No', 'PO Date', 'Created By', 'Vendor']
    const verifyParam = ['poNo', 'poDate', 'createdByName', 'vendorValue']

    useEffect(() => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLPO",
            "data": { "Company_ID": user?.businessId },
            "debug": null,
            "token": null
        }
        dispatch(getAllPo(data)).then(res => {
            setIsLoading(false)
        })
    }, [vendorList])

    useEffect(() => {
        let arr = []
        po.forEach((ele) => {
            const obj = { ...ele }
            obj['isActive'] = obj.isActive ? "Active" : obj.isActive ? "Non-Active" : '';
            obj['vendorValue'] = filterName(vendorList, obj.vendor_ID)
            arr.push(obj)
        })
        setPo(arr.reverse())

    }, [po])

    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Purchase Order (PO)</Typography>
                <PermissionComp list={['PO', 'create']}>
                    <ModalButton open={open} setOpen={setOpen} tooltip={'create'} type={'Button'}>
                        <PoForm setOpen={setOpen} />
                    </ModalButton>
                </PermissionComp>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end', padding: '0px 10px' }}>
                <Autocomplete
                    disablePortal
                    options={vendorList}
                    sx={{ width: '20%' }}
                    size="small"
                    getOptionLabel={(option) => {
                        return vendorList.find(e => (e.name == option.name))?.name || ""
                    }}
                    onChange={(_, data) => setVendor(data?.id)}
                    renderInput={(params) => <TextField {...params} label="Vendor" />}
                />
            </Box>
            <Card style={{ flex: 1, overflow: 'auto' }}>
                <TableContainer tableHeader={tableHeader}
                    data={vendor ? Po.filter(val => val.vendor_ID == vendor) : Po}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    action={TableAction} />
            </Card>
        </>
    );
};

export default Po;



const TableAction = ({ id }) => {
    const navigation = useNavigate()
    const [openDetail, setOpenDetail] = React.useState(false);
    const [openGRN, setOpenGRN] = React.useState(false);

    return (
        <Box>

            <PermissionComp list={['PO', 'detail']}>
                <ModalButton open={openDetail} setOpen={setOpenDetail} tooltip={'PO Details'} img={details} type={'icon'}>
                    <PoDetail state={id} setOpen={setOpenDetail} />
                </ModalButton>
            </PermissionComp>
            {/* <Tooltip title="Details">
                    <IconButton onClick={() => navigation('detail', { state: id })} sx={{ width: '40px', margin: '0px auto' }}>
                        <img src={details} style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                    </IconButton>
                </Tooltip> */}

            <PermissionComp list={['PO', 'grno']}>
                <ModalButton open={openGRN} setOpen={setOpenGRN} tooltip={'GR.NO'} img={receiver} type={'icon'}>
                    <Grn state={id} setOpen={setOpenGRN} />
                </ModalButton>
                {/* <Tooltip title="GR.NO">
                    <IconButton onClick={() => navigation('grno', { state: id })} sx={{ width: '40px', margin: '0px auto' }}>
                        <img src={receiver} style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                    </IconButton>
                </Tooltip> */}
            </PermissionComp>
        </Box>
    )
}